import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from 'src/app/services/account/language.service';
import { VehiclePropertyComponent, SliderProperty } from '../../../ui-panels/vehicle-panel/vehicle-property/vehicle-property.component';

@Component({
  standalone: true,
  selector: 'app-range-options',
  templateUrl: './range-options.component.html',
  styleUrls: ['./range-options.component.scss'],
  imports: [CommonModule, VehiclePropertyComponent]
})
export class RangeOptionsComponent {
  @Input() sliderProperties: SliderProperty[] = [];

  @Output() sliderDragEvent = new EventEmitter<{ id: string, value: number }>();
  @Output() sliderChangeEvent = new EventEmitter<{ id: string, value: number }>();

  constructor(public languageService: LanguageService) {}
}
